// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textarea/Primary.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextArea, css } from '@sail/ui';
import { EXAMPLE_TEXT } from './common';
export const Primary = () => <TextArea label="Biography" placeholder="Acme Inc was founded in…" defaultValue={EXAMPLE_TEXT} onChange={e => {
  // eslint-disable-next-line no-console
  console.log(e.target.value);
}} css={{
  width: css.value('350px')
}} />;